/**
 * Application Configuration
 * Centralized configuration management with environment variables
 */

export const config = {
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api.simiinfotech.com',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
    retryAttempts: parseInt(import.meta.env.VITE_API_RETRY_ATTEMPTS) || 3,
    retryDelay: parseInt(import.meta.env.VITE_API_RETRY_DELAY) || 1000,
  },

  search: {
    minQueryLength: 3,
    debounceDelay: 300,
    maxSuggestions: 10,
  },

  analytics: {
    gaTrackingId: import.meta.env.VITE_GA_TRACKING_ID || null,
    sentryDsn: import.meta.env.VITE_SENTRY_DSN || null,
  },

  environment: import.meta.env.VITE_ENV || 'production',

  isDevelopment: import.meta.env.DEV || false,
  isProduction: import.meta.env.PROD || true,
};

// Freeze config to prevent runtime modifications
Object.freeze(config);
Object.freeze(config.api);
Object.freeze(config.search);
Object.freeze(config.analytics);
